module.exports = __webpack_public_path__ + "img/skirt_2.1a3ec0bc.png";